import React from 'react';
import { SectionWrapper } from 'components/atoms/SectionWrapper.style';
import Slider from 'components/organisms/mainPageComponents/slider/Slider';
import WhyWe from 'components/organisms/mainPageComponents/whyWe/WhyWe';
import Gallery from 'components/organisms/mainPageComponents/gallery/Gallery';
import Contact from 'components/organisms/mainPageComponents/mainPageFooter/MainPageFooter';
import MainPageImg from 'components/organisms/mainPageComponents/mainPageImg/MainPageImg';
import styled from 'styled-components';
import { cms } from 'assets/cms';
import Header from 'components/organisms/header/Header';

const WrapperBackground = styled.div`
  height: 100%;
  background: center url(${cms.elgreen.lisc});
  /* background-size: contain; */
`;

const WrappepP = styled.div`
  padding-top: 150px;
`;

const MainPage = () => (
  <>
    {/* <WrapperBackground> */}
    {/* <MainPageImg></MainPageImg> */}
    <Header />
    {/* <MainPageImg /> */}
    {/* <SectionWrapper> */}
    <WrappepP>
      <p>Strona glowna w budowie </p>
    </WrappepP>
    {/* <Slider /> */}
    {/* <WhyWe /> */}
    {/* <Gallery /> */}
    {/* </SectionWrapper> */}
    {/* <Contact /> */}
    {/* </WrapperBackground> */}
  </>
);

export default MainPage;
